<script setup>
import {computed, ref} from 'vue'
import {useRouter} from 'vue-router/composables'
import Chat from './chat.vue'

const props = defineProps({
  // what the person was looking at: {path, title, type, id, gli}
  context: {type: Object, default: null},
  // reopen this conversation exactly (the navbar's "back to" a chat still working or unread)
  conversation: {type: Number, default: null},
})

const title = computed(() => (props.context && props.context.gli ? `Assistant - ${props.context.gli}` : 'OMS Assistant'))

const modalRef = ref(null)
const chatRef = ref(null)
const router = useRouter()

function openFull() {
  const id = chatRef.value && chatRef.value.conversationId
  if (!id) return
  modalRef.value.close()
  router.push(`/chat/${id}`).catch(() => {})
}
</script>

<template>
  <modal ref="modalRef" :title="title" size="lg" height="68vh" body-class="p-0">
    <template #buttons>
      <a href="#" class="text-white small mr-3 align-self-center" title="Start over with a new conversation"
         @click.prevent="chatRef && chatRef.newChat()">New chat</a>
      <a href="#" class="text-white small align-self-center" title="Open this conversation on the full chat page"
         @click.prevent="openFull">Open full page</a>
    </template>
    <chat ref="chatRef" embedded :context="context" :conversation="conversation"/>
  </modal>
</template>
